import type { FC, PropsWithChildren } from 'react';
import { Button, type ButtonProps } from '@mui/material';

export type ActionButtonProps = PropsWithChildren<ButtonProps>;

export const ActionButton: FC<ActionButtonProps> = ({ children, ...props }) => (
  <Button variant="contained" {...props}>
    {children}
  </Button>
);
